import React, { Component } from "react";

class ExceptionHandling extends Component {
  render() {
    return (
      <div>
        <p>Interaction with SmartConsole might result in an error.</p>
        <p>
          Error details are shown in the provided callback interaction (and
          logged in SmartConsole logs).
        </p>
        <table cellSpacing="0" cellPadding="0" className="tablesorter">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Code</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>operation-cancelled-by-user</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>Interaction was aborted by the user.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>generic_err_missing_required_parameters</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    Interaction was called without the required parameters.{" "}
                    <br />
                    See{" "}
                    <a href="#SmartConsole Interactions">
                      SmartConsole Interactions
                    </a>
                    .
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>not_implemented</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>Interaction does not exist. </span>
                  <span>
                    <br />
                    See{" "}
                    <a href="#SmartConsole Interactions">
                      SmartConsole Interactions
                    </a>
                    .
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>generic_err_invalid_syntax</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>Parameters are not JSON formatted.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>generic_err_no_permissions</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    Extension tried to execute an unauthorized operation.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>generic_error</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>Unknown error occurred.</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ExceptionHandling;
